import { MAX_DATE_RANGE_MONTHS } from "../constants";

export interface ErrorMapping {
  ftlId: string;
  vars?: Record<string, string | number>;
}

/**
 * Map an API error code (the `id` field of the error envelope) to a localized
 * Fluent string. Unknown/missing codes fall back to the generic export error.
 */
export const pickExportErrorMapping = (
  code: string | undefined
): ErrorMapping => {
  switch (code) {
    case "date_range_too_large":
      return {
        ftlId: "transaction-export-error-date-range-too-large",
        vars: { months: MAX_DATE_RANGE_MONTHS },
      };
    default:
      return { ftlId: "transaction-export-error" };
  }
};

/** Read the backend error code from an ApiHttp (rawResponse) error. */
export const extractBackendCode = (error: unknown): string | undefined => {
  if (typeof error !== "object" || error === null) return undefined;
  const { response } = error as { response?: { data?: unknown } };
  if (
    !response ||
    typeof response.data !== "object" ||
    response.data === null
  ) {
    return undefined;
  }
  const { id } = response.data as { id?: unknown };
  return typeof id === "string" ? id : undefined;
};
